import {ColumnMain} from "../column-main";
import {Column} from "../column";
import {Trans} from "@lingui/macro";
import React from "react";

const ProductModel = () : ColumnMain =>
{

    const columns : Array<Column> = new Array();

    const productColumns: Array<Column> = new Array();
    productColumns.push({key:'code', width: 200, sorter:true, fixed: "left", title:<Trans>Code</Trans>, render: (text, row) => ({ props: { style: { background: '#fbfbfb'} }, children: <div>{text}</div> })});
    productColumns.push({key:'name', width: 350, sorter:true, fixed: "left", title:<Trans>Name</Trans>, render: (text, row) => ({ props: { style: { background: '#fbfbfb'} }, children: <div>{text}</div> })});
    columns.push({
        key: 'product',
        fixed: "left",
        width: 157,
        sorter: false,
        filter: false,
        title: <Trans>Product</Trans>,
        children: productColumns,
    });

    columns.push({key:'color', width: 200, sorter:true,title:<Trans>Color</Trans> });
    columns.push({key:'type', width: 200, sorter:true,title:<Trans>Type</Trans> });
    columns.push({key:'size.name', dataIndex:['size','name'], width: 110, sorter:false,title:<Trans>Size</Trans>});
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, dateFilter:true, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, direction:"desc", dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>});
    columns.push({key:'createdBy', width: 200, dateFilter:true, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/products"
    };

}

export default ProductModel();
